import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const StopDeviceAlarmRequestModalWrapper = styled(Modal)`
  .ant-modal-body{
    padding: 20px;
  }
  /* Save carries a loading spinner while the termination is in flight, which
     makes it a different height from Cancel; baseline alignment stops the
     footer shifting as it spins. Scoped to this modal on purpose — the global
     .ant-modal-footer rule is shared by every modal in the app. */
  .ant-modal-footer{
    align-items: baseline;
  }
  iframe{
    width: 100%;
    height: 100%
  }
  .btn-success{
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    margin-top: 20px
  }
  .form-title{
    padding: 16px 24px;
    border-bottom: 1px solid #eaeef1;
    h3{
      font-size: 1rem;
    }
  }
  .form-body{
    padding: 12px 24px 12px 24px;
    .checkbox-contact{
      margin-bottom: 10px;
    }
  }

  .signature-area canvas{
    border: solid 1px black;
    max-width: 100%;
  }

  .signature-image {
    width: 100%;
  }

  .signature-clear-button {
    display: block;
  }

  .form-qr-area {
    justify-content: center;
    display: flex;
    margin-bottom: 30px;
    flex-direction: column;
    align-items: center;
    .ant-typography {
      margin-top: 20px;
      padding: 5px;
      border: 1px solid #719E67;
      border-radius: 5px;
      svg {
        fill: #719E67;
      }
    }
  }

  .btn-view-form {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .visitor-information{
    padding: 15px;
    border: 1px solid #dbdbdb;
    border-radius: 10px;
    margin-bottom: 10px;
    .visitor-title{
      margin-bottom: 10px
    }
  }
  #property-address{
    font-size: 15px
  }
`;

export default WithDirection(StopDeviceAlarmRequestModalWrapper);